import React from 'react';

export const AlignLeft = ({
  className,
  color = '#7D7A9A',
  width = '17px', 
  height = '18px',
}: {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.59277 7.91748L11.8299 7.91748"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M3.59277 5.09864L12.7563 5.09863"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M3.59277 10.7505L13.4067 10.7505"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M3.59277 13.584L7.8094 13.584"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
